import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { TenantSubscriptionService } from 'src/app/services/tenants/tenant-subscription.service';

@Component({
  selector: 'app-activate-publishing-mode-modal',
  standalone: false,
  templateUrl: './activate-publishing-mode-modal.component.html',
  styleUrl: './activate-publishing-mode-modal.component.scss'
})
export class ActivatePublishingModeModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input() hasSubscription = true;

  @Input() publishToSubscribers = false;
  @Output() publishToSubscribersChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onActivate = new EventEmitter();
  
  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private tenantSubscriptionService: TenantSubscriptionService
  ) {
   
  }

  activate() {
    if(this.hasSubscription) {
      this.loadingService
        .load(
          this.tenantSubscriptionService.activatePublishingMode()
        )
        .subscribe(() => {
          this.toastrService.success(
            this.translateService.instant(
              'PUBLISHING-MODE.ACTIVATE-PUBLISHING-MODE.ACTIVATED-PUBLISHING-MODE-SUCCESSFULLY'
            )
          );
          this.publishToSubscribers = true;
          this.publishToSubscribersChange.emit(this.publishToSubscribers);

          this.onActivate.emit();
          this.close();
        });
    } else {
      this.publishToSubscribers = true;
      this.publishToSubscribersChange.emit(this.publishToSubscribers);

      this.onActivate.emit();
      this.close();
    }
  }

  cancel() {
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
